import { render, staticRenderFns } from "./RnsReverseLookup.vue?vue&type=template&id=ffc67b56"
import script from "./RnsReverseLookup.vue?vue&type=script&lang=js"
export * from "./RnsReverseLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports